var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilled214X214 = function SvgFilled214X214(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 290 290"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 214.229,
    height: 214.229,
    x: 3.534,
    y: 0.1,
    rx: 22.908,
    transform: "scale(1 -1)rotate(-46.625 -164.744 -58.657)"
  })));
};
export default SvgFilled214X214;